import React, { useCallback } from 'react';
import { useUniqueId } from '../utils/useUniqueID';
import { useDescribers } from '../utils/useDescribers';
import { getPlaceholder } from '../utils/helperFunctions';
import { TextInputBase } from '../TextInputBase/TextInputBase';
import { css } from '@emotion/css';
export const validResizes = ['none', 'vertical'];
const textboxStyles = (resize) => css `
  resize: ${resize};
`;
export const TextArea = React.forwardRef(({ 'aria-label': ariaLabel, className, ContainerProps, containerRef, endAdornment, error, guidance, help, id, isDisabled = false, isRequired, label, onChange, placeholder, startAdornment, style, testId, units, value, resize = 'none', rows = 2, ...rest }, ref) => {
    if (!validResizes.includes(resize)) {
        throw new Error(`Invalid resize, valid resizes are [${validResizes}] and you passed in [${resize}].`);
    }
    if (rows < 1) {
        throw new Error(`Invalid rows, valid rows are greater than 1 and you passed in [${rows}].`);
    }
    const uniqueId = useUniqueId(id);
    const describers = useDescribers({ help, uniqueId, guidance });
    const onTextChange = useCallback((event) => {
        if (!isDisabled) {
            onChange(event, event.target.value);
        }
    }, [isDisabled, onChange]);
    return (React.createElement(TextInputBase, { componentName: "TextArea", uniqueId: uniqueId, "aria-label": ariaLabel, className: className, ContainerProps: ContainerProps, containerRef: containerRef, endAdornment: endAdornment, error: error, guidance: guidance, help: help, isDisabled: isDisabled, label: label, placeholder: placeholder, startAdornment: startAdornment, style: style, testId: testId, units: units },
        React.createElement("textarea", { required: isRequired, id: uniqueId, disabled: isDisabled, ref: ref, value: value || '', "data-testid": testId, onChange: onTextChange, 
            // by not having a placeholder to show we will always be in a state where placeholdershown is false putting the label in the top section
            placeholder: getPlaceholder(placeholder, !!startAdornment), "aria-describedby": describers, "aria-errormessage": `${uniqueId}-error`, "aria-invalid": !!error, "aria-label": ariaLabel, className: textboxStyles(resize), rows: rows, ...rest })));
});
TextArea.displayName = 'TextArea';
